import * as React from 'react';
import { Navigate } from 'react-router-dom';

import { PrivateLayoutContainer } from '@/components/Containers/PrivateLayoutContainer/PrivateLayoutContainer';
import { NotFound } from '@/components/Layout';
import {
  ActivationPage,
  FeatureComparatorPage,
  MyAccountPage,
  MyInvoicesPage,
  MyRatePage,
  ProductsUpdatePage,
  PurchasePage,
  UpdatePaymentMethodPage,
  FaqsPage,
} from '@/features/misc';

export const privateRoutes = [
  {
    path: '/account',
    element: <PrivateLayoutContainer />,
    children: [
      { path: 'products', element: <ProductsUpdatePage /> },
      { path: 'my-invoices', element: <MyInvoicesPage /> },
      { path: 'feature-comparator', element: <FeatureComparatorPage isLogged={true} /> },
      { path: 'faqs', element: <FaqsPage /> },
      { path: '/account/', element: <Navigate to="my-account" /> },
      { path: '*', element: <NotFound /> },
    ],
  },
  {
    path: '/account/my-rate',
    element: <PrivateLayoutContainer hiddenNotification={true} />,
    children: [
      { path: ':checkout', element: <MyRatePage completeCheckout={true} /> },
      { path: '', element: <MyRatePage /> },
    ],
  },
  {
    path: '/account/my-account',
    element: <PrivateLayoutContainer hiddenNotification={true} />,
    children: [{ path: '', element: <MyAccountPage /> }],
  },
  {
    path: '/account/purchase',
    element: (
      <PrivateLayoutContainer hiddenHeader={true} hiddenFooter={true} hiddenNotification={true} />
    ),
    children: [
      { path: ':productPriceId', element: <PurchasePage /> },
      { path: '', element: <PurchasePage /> },
    ],
  },
  {
    path: '/account/checkout',
    element: <PrivateLayoutContainer hiddenNotification={true} />,
    children: [
      { path: ':mdirectorId/:currency', element: <MyRatePage autoCheckout={true} /> },
      { path: ':mdirectorId/:currency/:comID', element: <MyRatePage autoCheckout={true} /> },
      {
        path: ':mdirectorId/:currency/:interval',
        element: <MyRatePage autoCheckout={true} />,
      },
      {
        path: ':mdirectorId/:currency/:interval/:comID',
        element: <MyRatePage autoCheckout={true} />,
      },
      {
        path: ':mdirectorId/:currency/:interval/:comID/:signature',
        element: <MyRatePage autoCheckout={true} />,
      },
      { path: '*', element: <NotFound /> },
    ],
  },
  {
    path: '/account/activation',
    element: (
      <PrivateLayoutContainer hiddenHeader={true} hiddenFooter={true} hiddenNotification={true} />
    ),
    children: [
      { path: ':mdirectorId', element: <ActivationPage /> },
      { path: ':mdirectorId/:billingMode', element: <ActivationPage /> },
      { path: ':mdirectorId/:billingMode/:currency', element: <ActivationPage /> },
      { path: ':mdirectorId/:billingMode/:currency/:landingname', element: <ActivationPage /> },
      { path: '', element: <ActivationPage /> },
    ],
  },
  {
    path: '/account/update-payment-method',
    element: (
      <PrivateLayoutContainer hiddenHeader={true} hiddenFooter={true} hiddenNotification={true} />
    ),
    children: [{ path: '', element: <UpdatePaymentMethodPage /> }],
  },
];
